/* src/app/components/payroll/timesheets/timesheet-consumer-list/timesheet-consumer-list.component.css */
.line1 {
  display: flex;
  justify-content: space-between;
}
.filters {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.ant-select-selector {
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}
.check-filter {
  width: 100%;
  height: 32px;
  padding: 0 11px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.85);
}
:host ::ng-deep .accordion-body {
  gap: 12px !important;
}
.message {
  margin-bottom: 0px;
  margin-top: 16px;
  margin-left: 8px;
  font-weight: 500;
  width: auto !important;
}
:host ::ng-deep .in-process th {
  width: 11% !important;
}
.ant-form-item {
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
}
/*# sourceMappingURL=timesheet-consumer-list.component-XGWXJ7FV.css.map */
